import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

const CollapsibleSection = ({
    title,
    level,
    isCurrentLevel = false,
    isNextLevel = false,
    defaultExpanded = false,
    onExpand,
    children
}) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    // Update expanded state when defaultExpanded prop changes (e.g., when skill level is set)
    useEffect(() => {
        setIsExpanded(defaultExpanded);
    }, [defaultExpanded]);

    const getBadge = () => {
        if (isCurrentLevel) {
            return (
                <span className="ml-2 px-2 py-0.5 bg-primary/20 text-primary text-xs font-bold rounded-full border border-primary">
                    YOUR LEVEL
                </span>
            );
        }
        if (isNextLevel) {
            return (
                <span className="ml-2 px-2 py-0.5 bg-secondary/20 text-secondary text-xs font-bold rounded-full border border-secondary">
                    NEXT
                </span>
            );
        }
        return null;
    };

    const getSectionClasses = () => {
        const base = "rounded-xl border-2 transition-all duration-300";
        if (isCurrentLevel) {
            return `${base} border-primary bg-primary/5`;
        }
        if (isNextLevel) {
            return `${base} border-secondary/50 bg-secondary/5`;
        }
        return `${base} border-border bg-surface`;
    };

    return (
        <div className={getSectionClasses()}>
            {/* Header */}
            <button
                onClick={() => {
                    const newExpandedState = !isExpanded;
                    setIsExpanded(newExpandedState);
                    if (newExpandedState && onExpand) {
                        onExpand();
                    }
                }}
                className="w-full flex items-center justify-between p-4 text-left hover:bg-surface-hover/50 transition-colors rounded-t-xl"
                aria-expanded={isExpanded}
                aria-controls={`section-${level}`}
            >
                <div className="flex items-center gap-2">
                    {isExpanded ? (
                        <ChevronDown className="text-primary" size={20} />
                    ) : (
                        <ChevronRight className="text-muted" size={20} />
                    )}
                    <h3 className={`text-lg font-bold ${isCurrentLevel ? 'text-primary' : 'text-main'}`}>
                        {title}
                    </h3>
                    {getBadge()}
                </div>

                {!isExpanded && (
                    <span className="text-xs text-muted">
                        Click to expand
                    </span>
                )}
            </button>

            {/* Content */}
            {isExpanded && (
                <div
                    id={`section-${level}`}
                    className="p-4 pt-0 space-y-3 animate-fadeIn"
                >
                    {children}
                </div>
            )}
        </div>
    );
};

export default CollapsibleSection;
